export class PaymentHistoryState {
  public list: PaymentHistoryList
  public byId: IPaymentHistory
  public update: object

  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.byId = {
      _id: '',
      jobId: '',
      name: '',
      accountNumber: '',
      bank: '',
      amount: 0,
      slipImg: '',
      status: '',
      centerId: '',
    }
  }
}

export interface PaymentHistoryList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: Array<{
    _id: string,
    jobId: string,
    name?: string,
    slipImg?: string,
    amount: number,
    status: string,
    accountNumber: string,
    bank: string,
    createdAt?: number,
    updatedAt?: number,
  }>
}

export interface IPaymentHistory {
    _id: string,
    jobId: string,
    amount: number,
    name: string,
    accountNumber: string,
    bank: string,
    status: string,
    centerId: string,
    slipImg?: string,
}

export default PaymentHistoryState
